// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import PropTypes from 'prop-types'
import { TrackingProvider } from '@indeed/flex-tracking-context'

import EmployerAccountsDetail from 'syft-acp-core/entities/EmployerDetail/EmployerAccountsDetail'
import SubNavigation from 'syft-acp-core/components/Navigation/SubNavigation'
import PageTitle, { recordLabel, useEmployerName } from 'syft-acp-core/components/PageTitle'

const EmployerAccountsNew = ({ match: { params } }) => {
  const employerName = useEmployerName(Number(params.id))

  return (
    <TrackingProvider
      value={{
        context: {
          employer_id: Number(params.id),
        },
      }}
    >
      <PageTitle title={['New account', recordLabel('Employer', params.id, employerName)]}>
        <SubNavigation subPage="employers" data={{ employerID: Number(params.id) }} />
        <EmployerAccountsDetail id={0} employerID={Number(params.id)} />
      </PageTitle>
    </TrackingProvider>
  )
}

EmployerAccountsNew.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      // Note: ID gets passed as a string directly from the URL.
      id: PropTypes.string.isRequired,
    }).isRequired,
  }),
}

export default EmployerAccountsNew
